export interface PromptTemplate {
  id: string;
  label: string;
  prompt: string;
}

export const PROMPT_TEMPLATES: ReadonlyArray<PromptTemplate> = [
  {
    id: 'default',
    label: 'Common Prompt',
    prompt: '<COMMON_PROMPT>',
  },
  {
    id: 'high_ticket',
    label: 'High Ticket',
    prompt:
      'Eres un asistente de venta para propiedades de alto valor. Atiende al lead con foco en su intención de compra y agenda visitas.',
  },
  {
    id: 'rent',
    label: 'Arriendo',
    prompt:
      'Eres un asistente para arriendos. Recoge presupuesto, comuna preferida, fecha de mudanza y agenda una visita cuando corresponda.',
  },
  {
    id: 'sale',
    label: 'Venta',
    prompt:
      'Eres un asistente para venta de propiedades. Califica al lead, captura datos financieros básicos y agenda una visita.',
  },
];

export const getPromptTemplateById = (id: string): PromptTemplate | undefined =>
  PROMPT_TEMPLATES.find((template) => template.id === id);
